import { render } from "./CreateShift.vue?vue&type=template&id=edf27060"
import script from "./CreateShift.vue?vue&type=script&lang=js"
export * from "./CreateShift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__